import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';

export const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-content">
        {/* Announcement Badge */}
        <div className="hero-announcement">
          <Sparkles size={14} />
          <span>Platform Hukum AI Pertama di Indonesia</span>
        </div>

        {/* Main Heading */}
        <h1 className="heading-hero mb-6">
          Solusi Pengetahuan Hukum<br />
          Berbasis <span style={{ 
            background: 'linear-gradient(135deg, #987D9C 0%, #BCA182 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>Artificial Intelligence</span>
        </h1>

        {/* Subtitle */}
        <p className="body-large mb-8" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto 2rem' }}>
          IndoHukum.id menggabungkan keahlian hukum dengan teknologi AI untuk memberikan 
          analisis regulasi, konsultasi hukum instan, dan pembuatan kebijakan berbasis data.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button onClick={() => scrollToSection('hukum-pedia')} className="btn-primary flex items-center gap-2">
            Jelajahi Hukum Pedia
            <ArrowRight size={16} />
          </button>
          <button onClick={() => scrollToSection('profil')} className="btn-secondary">
            Pelajari Lebih Lanjut
          </button>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="heading-1" style={{ color: 'var(--text-primary)' }}>1000+</div>
            <div className="body-small" style={{ color: 'var(--text-muted)' }}>Regulasi Terindeks</div>
          </div>
          <div className="text-center">
            <div className="heading-1" style={{ color: 'var(--text-primary)' }}>50+</div>
            <div className="body-small" style={{ color: 'var(--text-muted)' }}>Policy Brief</div>
          </div>
          <div className="text-center">
            <div className="heading-1" style={{ color: 'var(--text-primary)' }}>100+</div>
            <div className="body-small" style={{ color: 'var(--text-muted)' }}>Klien Puas</div>
          </div>
          <div className="text-center">
            <div className="heading-1" style={{ color: 'var(--text-primary)' }}>24/7</div>
            <div className="body-small" style={{ color: 'var(--text-muted)' }}>AI Chatbot</div>
          </div>
        </div>
      </div>
    </section>
  );
};
